export default __webpack_public_path__ + "static/media/no-data.9c011c38.jpg";